// extracted by mini-css-extract-plugin
module.exports = {"VideoModule":"VideoModule_VideoModule__3kVci"};